<template>
  <div class="btngroup-radio">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BtngroupRadio",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btngroup-radio {
  @include flex(flex, flex-start, center, row, wrap);
  margin-right: 0px;
  margin-bottom: -10px;
  max-width: 100%;
  box-sizing: border-box;
  @include mq-up(md) {
    margin-right: -10px;
    margin-bottom: -10px;
  }
  :deep(.btn-radio) {
    margin-right: 10px;
    margin-bottom: 10px;
    @include mq-down(md) {
      &:nth-child(even) {
        margin-right: 0px;
      }
    }
  }
  &.-center {
    @include flex(flex, center, center, row, wrap);
    :deep(.btn-radio) {
      @include mq-down(md) {
        width: auto;
      }
    }
  }
}
</style>
